// /src/components/ImageModal.js

import React from 'react';
import Modal from 'react-modal';

function ImageModal({ isOpen, onClose, src, className, overlayClassName }) {
    // Détecter si l'appareil est un mobile ou une tablette
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const handleContentClick = (e) => {
        if (isMobile) {
            e.stopPropagation(); // Empêcher la propagation pour les clics à l'intérieur de la modal
            onClose(); // Fermer la modal
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose} // Permet la fermeture lors du clic sur l'overlay
            shouldCloseOnOverlayClick={true}
            className={className} // Utilisez des styles définis en SCSS
            overlayClassName={overlayClassName} // Utilisez des styles définis en SCSS
        >
            <div onClick={handleContentClick} className="modal-content-wrapper">
                <img src={src} alt="Modal" className="modal-image" />
            </div>
        </Modal>
    );
}

export default ImageModal;
